const DATABASE = `https://fakegramm.herokuapp.com`;

export default DATABASE;
